import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import { WSFightData } from 'shared';
import useAlert from '../../../../../contexts/alert';
import useWs from '../../../../../contexts/websockets';
import {
  useWsToHttp,
  WSError
} from '../../../../../hooks/wsToHttp/useWsToHttp';
import BattleAction from './Content';
import Loader from '../../../../general/loader';
import Button from '../../../../controls/button';
import useInitFight from '../../../../../contexts/initFight';
import { IFightNft } from '../../../../../interfaces/FightNft';

interface Props {
  nft: IFightNft;
  bet: number;
  next: (fightId: string) => void;
}

const BattleActionStage = ({ nft, bet, next }: Props) => {
  const alert = useAlert();
  const { goHome } = useInitFight();
  const { wsConnected } = useWs();
  const alreadyConnected = useRef(false);
  const { getFightData } = useWsToHttp();
  const [error, setError] = useState<WSError | false>(false);
  const [fightData, setFightData] = useState<WSFightData>();

  useEffect(() => {
    if (wsConnected) {
      if (!alreadyConnected.current) {
        alreadyConnected.current = true;
        init();
      }
    } else {
      alreadyConnected.current = false;
    }
  }, [wsConnected]);

  const init = () => {
    getFightData()
      .then((data) => {
        setFightData(data);
      })
      .catch((err: WSError) => {
        setError(err);
        alert.showError(err.error);
      });
  };

  if (error) {
    return (
      <>
        <h1>Error!</h1>
        <h4>{error.error}</h4>
        {error.status === 404 && (
          <p style={{ marginTop: 20, textAlign: 'center', maxWidth: 400 }}>
            If you're here after reconnect, most probably your fight was
            reverted, and you got your $cream back
          </p>
        )}
        <Button onClick={goHome} style={{ marginTop: 30 }}>
          Go Home
        </Button>
      </>
    );
  }

  if (fightData) {
    return <BattleAction data={fightData} nft={nft} bet={bet} next={next} />;
  }

  return <Loader useAbsoluteWrapper />;
};

export default BattleActionStage;
